export default "__VITE_ASSET__aa8c902e__"